import '@progress-wad/site-polyfills/build/polyfills.js';
import './modules/dataloader.js';
import './modules/details-summary.js';
import './modules/support-css-property.js';
import './modules/sharer.js';
import './modules/toggle.js';
import './modules/toggle-self.js';
import './modules/switch-nav.js';
import './modules/section-patch.js';
import './modules/animations-polyfill.js';
import '@progress-wad/litebox';
import '@progress-wad/siema-slider';
import '@progress-wad/sticky-element';
import './modules/set-active-link.js';
import '@progress-wad/site-search/src/init.js';
import '@progress-wad/youtube-lite-embed/dist/index.mjs';
import { MultiSelect } from '@progress-wad/multi-select';

// dom ready
document.addEventListener('DOMContentLoaded', () => {
  MultiSelect.init();
});
